import { z } from 'zod';

export const formSchema = z.object({
  observation: z.string({ required_error: 'Informe a observação' }),
});

export type FormSchema = z.infer<typeof formSchema>;
